import { render, staticRenderFns } from "./AllowedTimes.vue?vue&type=template&id=f7477e10&"
import script from "./AllowedTimes.vue?vue&type=script&lang=js&"
export * from "./AllowedTimes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports